import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointoramaWallSketch } from '../../../../potree/utils/PointoramaWallSketch';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];

export function createSyncWallSketchesConfig({
  viewer,
  annotations,
  wallSketchPropertiesLoading,
}: {
  viewer: NonNullable<RendererContextType['viewer']>;
  annotations: Annotation[];
  wallSketchPropertiesLoading: boolean;
}): SyncConfig<Annotation, PointoramaWallSketch> {
  return {
    getSourceItems: () => {
      if (wallSketchPropertiesLoading) return null;
      return annotations.filter((a) => a.type === 'WALL_SKETCH');
    },
    getSceneItems: () => [...(viewer.scene.wallSketches || [])],
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry updates are handled by reactive property subscriptions
    create: (source) => {
      // WallSketch loads geometry from property system when identifier is set
      // (triggers loadReactiveProperties). groupIdentifier must be set FIRST:
      // 3D skinning follows the floor's `floor_mesh3d_enabled`, which
      // loadReactiveProperties resolves via groupIdentifier.
      const skeleton = new PointoramaWallSketch(viewer);
      skeleton.groupIdentifier = source.groupIdentifier || null;
      skeleton.identifier = source.identifier;
      skeleton.finished = true;
      return skeleton;
    },
    addToScene: (item) => viewer.scene.addWallSketch(item),
    removeFromScene: (item) => viewer.scene.removeWallSketch(item),
  };
}
